import { refreshTooltips } from './utils.js';

$(document).ready(refreshTooltips);
